import { router } from '@inertiajs/vue3';

export function useContribuinteNavigation() {
    const getAreaContribuinteRoute = () => route('contribuinte');
    const getMeusDebitosRoute = () => route('contribuinte.meus-debitos');
    const getMeusImoveisRoute = () => route('contribuinte.meus-imoveis');
    const getDebitosPorImovelRoute = (matriculaId) => route('contribuinte.meus-imoveis.debitos', { matriculaId });
    const getMinhasInscricoesRoute = () => route('contribuinte.minhas-inscricoes');
    const getDebitosPorInscricaoRoute = (inscricao) => route('contribuinte.minhas-inscricoes.debitos', { inscricao });

    const goToAreaContribuinte = () => router.visit(getAreaContribuinteRoute());
    const goToMeusDebitos = () => router.visit(getMeusDebitosRoute());
    const goToMeusImoveis = () => router.visit(getMeusImoveisRoute());
    const showDebitosPorImovel = (matriculaId) => router.visit(getDebitosPorImovelRoute(matriculaId));
    const goToMinhasInscricoes = () => router.visit(getMinhasInscricoesRoute());
    const showDebitosPorInscricao = (inscricao) => router.visit(getDebitosPorInscricaoRoute(inscricao));

    return {
        getAreaContribuinteRoute, getMeusDebitosRoute, getMeusImoveisRoute, getDebitosPorImovelRoute,
        getMinhasInscricoesRoute, getDebitosPorInscricaoRoute,
        goToAreaContribuinte, goToMeusDebitos, goToMeusImoveis, showDebitosPorImovel,
        goToMinhasInscricoes, showDebitosPorInscricao
    };
}
